import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);
export function getAbsoluteHeight(el) {
  // Get the DOM Node if you pass in a string
  el = typeof el === "string" ? document.querySelector(el) : el;

  var styles = window.getComputedStyle(el);
  var margin =
    parseFloat(styles["marginTop"]) + parseFloat(styles["marginBottom"]);

  return Math.ceil(el.offsetHeight + margin);
}

export function createZoomInBanner(section) {
  const animationDirection = section.dataset.animationDirection;
  const animationReverse = animationDirection === "reverse";
  const animationExpand = animationDirection === "expand";

  const customBottleFloating = section.querySelector(
    "#custom-bottle-floating img"
  );

  const banner = section.querySelector(".zoom-in-banner__wrapper"); // OK
  const wpBlockCover = banner.querySelector(".wp-block-cover"); // .wp-block-cover so this is the main wrapper
  const isLight = wpBlockCover.classList.contains("is-light");

  const asset = wpBlockCover.querySelector(".wp-block-cover__image-background");
  const overlay = wpBlockCover.querySelector(".wp-block-cover__background");

  const textBlock = section.querySelector(".wp-block-cover__inner-container");

  if (!asset) return;

  const videoEl = asset.querySelector("video");

  const isDesktop = window.innerWidth >= 1024;

  const scaleAttrs = isDesktop ? { scale: 0.9, borderRadius: "24px" } : null;

  if (!animationReverse && !animationExpand) {
    let animationPlayed = false;

    gsap.set(section, {
      overflow: "hidden",
    });

    const tl = gsap.timeline({
      paused: true,
      onComplete: () => videoEl?.play(),
      onReverseComplete: () => videoEl?.pause(),
    });

    tl.timeScale(0.5); // Reproduce el timeline a la mitad de velocidad (más lento)

    if (customBottleFloating) {
      tl.fromTo(
        customBottleFloating,
        {
          scale: 1,
          yPercent: 100,
        },
        {
          yPercent: 0,
          duration: 1,
          scale: 1.5,
          ease: "expo.out",
        },
        "End"
      );
    }

    tl.addLabel("Start");

    tl.add(() => {
      banner.dataset.mode = "dark";
    });

    tl.addLabel("ChangeMode");

    tl.fromTo(
      textBlock,
      {
        ...(!isLight && { color: "#000" }),
        onStart: () => banner.removeAttribute("data-mode"),
      },
      {
        duration: 1,
        ...(!isLight && { color: "#fff" }),
        ease: "expo.out",
      },
      "Start"
    );

    tl.fromTo(
      [asset, overlay],
      {
        yPercent: 75,
      },
      {
        yPercent: 0,
        ease: "expo.out",
        duration: 0.8,
      },
      "Start"
    );

    tl.from(overlay, { opacity: 0 }, "ChangeMode>-=1");

    if (scaleAttrs !== null) {
      tl.fromTo(
        [asset, overlay],
        {
          ...scaleAttrs,
        },
        {
          ease: "expo.inOut",
          duration: 1,
        },
        ">-=0.5"
      );
    }

    tl.addLabel("End");

    ScrollTrigger.create({
      trigger: section,
      start: "top 80%",
      toggleActions: "play none none none",
      onEnter: () => {
        if (animationPlayed) return;
        tl.pause(0).play();
        animationPlayed = true;
      },
    });
  } else if (animationReverse) {
    let animationPlayed = false;

    const tl = gsap.timeline({
      paused: true,
      onComplete: () => videoEl?.play(),
      onReverseComplete: () => videoEl?.pause(),
    });

    tl.timeScale(0.5); // Reproduce el timeline a la mitad de velocidad (más lento)

    tl.addLabel("Start");

    if (scaleAttrs !== null) {
      tl.fromTo(
        [asset, overlay],
        {
          scale: 1,
          borderRadius: "0px",
          transformOrigin: "center",
        },
        {
          ...scaleAttrs,
          duration: 1,
          ease: "expo.inOut",
        },
        ">-=0.5"
      );
    }

    tl.from(overlay, { opacity: 0, duration: 1 }, "Start>-=0.5");

    tl.fromTo(
      textBlock,
      { opacity: 0 },
      { opacity: 1, duration: 1, ease: "expo.out" },
      "Start"
    );

    if (customBottleFloating) {
      tl.fromTo(
        customBottleFloating,
        { scale: 1, yPercent: 100 },
        { yPercent: 0, scale: 1.5, duration: 1, ease: "expo.out" },
        "<"
      );
    }

    ScrollTrigger.create({
      trigger: section,
      start: "top 80%",
      toggleActions: "play none none none",
      onEnter: () => {
        if (animationPlayed) return;
        tl.pause(0).play();
        animationPlayed = true;
      },
    });
  } else if (animationExpand) {
    let animationPlayed = false;

    const tl = gsap.timeline({
      paused: true,
      onComplete: () => videoEl?.play(),
      onReverseComplete: () => videoEl?.pause(),
    });

    tl.timeScale(0.5);

    tl.addLabel("Start");

    if (scaleAttrs !== null) {
      tl.fromTo(
        [asset, overlay],
        {
          ...scaleAttrs,
          transformOrigin: "center",
        },
        {
          scale: 1,
          borderRadius: "0px",
          duration: 1,
          ease: "expo.inOut",
        },
        "Start"
      );
    }

    tl.from(overlay, { opacity: 0, duration: 1 }, "Start>-=0.5");

    tl.fromTo(
      textBlock,
      { opacity: 0 },
      { opacity: 1, duration: 1, ease: "expo.out" },
      "Start"
    );

    if (customBottleFloating) {
      tl.fromTo(
        customBottleFloating,
        { scale: 1, yPercent: 100 },
        { yPercent: 0, scale: 1.5, duration: 1, ease: "expo.out" },
        "<"
      );
    }

    ScrollTrigger.create({
      trigger: section,
      start: "top 80%",
      toggleActions: "play none none none",
      onEnter: () => {
        if (animationPlayed) return;
        tl.pause(0).play();
        animationPlayed = true;
      },
    });
  }
}
